import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { faQuoteRight } from '@fortawesome/pro-light-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  CitationExportContentComponent
} from '../../../citation/components/citation-modal-window/citation-modal-window.component';
import { EditionData } from '../../../citation/models/editions';
import { EntityTypes } from '../../../entity/models/entity';

@Component({
  selector: 'app-citation-mailing-button',
  templateUrl: './citation-mailing-button.component.html',
  styleUrls: ['./citation-mailing-button.component.scss']
})
export class CitationMailingButtonComponent implements OnChanges {
  @Input() public entityType: EntityTypes;
  @Input() public editionsData: EditionData[];
  @Input() ariaDescribedBy: string | null = null;
  @Input() public smallButton = false;
  @Input() public disabled: boolean;
  public quoteIcon = faQuoteRight;
  public isCitationVisible = false;

  constructor(private modal: NgbModal) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.editionsData && changes.entityType) {
      this.isCitationVisible = changes.editionsData.currentValue &&
        [EntityTypes.FORMAT_GROUP, EntityTypes.INSTANCE].includes(changes.entityType.currentValue);
    }
  }

  onCitation(): void {
    const modalRef = this.modal.open(CitationExportContentComponent, {
      windowClass: 'inspire-custom-modal',
      ariaDescribedBy: this.ariaDescribedBy,
    });

    modalRef.componentInstance.editionsData = this.editionsData;
  }
}
